import React from 'react';
import { Spinner } from 'reactstrap';
import './styles/FullPageSpinner.css'; // Aquí puedes añadir estilos

const FullPageSpinner = ({ message }) => {
  return (
    <div className="full-page-spinner">
        <div style={{display: "flex", alignItems: "center"}}>
            <Spinner color="light" />
            <p style={{margin: 0, marginLeft: '16px'}}>{message}</p>
        </div>
      
    </div>
  );
};

export default FullPageSpinner;